import { gql } from '@apollo/client';

export const fetchDealRegistrationsByPartnerId = gql`
  query fetchDealRegistrationsByPartnerId(
    $options: DealRegistrationFilterOptions
    $pageParams: DealRegistrationPageParams
  ) {
    dealRegistrations(options: $options, pageParams: $pageParams) {
      totalCount
      nodes {
        registrationName
        programName
        typeOfDeal
        linkedCustomerAccount
        atlassianSalesRep
        atlassianSolutionSalesExecRep
        registrationStatus
        dealId
        linkedPartnerOpportunity
        gsacTicket
        approvalId
        dateOfSubmission
        dateOfExpiration
        denialReason
        comments
        statementOfWorkAmount
        purchaseOrderAmount
        extensionStatus
      }
    }
  }
`;
